import StaticText from './StaticText';
export default StaticText;
